import { useEffect, useState } from 'react';

import { LessonComponentBase } from '../../content/models/LessonComponent';
import { cloneDeep } from 'lodash';
import { useComponents } from './useComponents';
import { useModuleVersionMaps } from './useModuleVersionMaps';

export function useLessonComponents(modulekey: number, moduleVersion: number) {
  const [lessonComponents, setLessonComponents] = useState<
    LessonComponentBase[] | null
  >(null);

  const {
    error: componentsLoadError,
    data: apiComponents,
    update: updateComponents
  } = useComponents(modulekey, moduleVersion);
  const {
    error: mapsLoadError,
    data: versionMaps,
    update: updateVersionMaps
  } = useModuleVersionMaps(modulekey, moduleVersion);

  useEffect(() => {
    if (
      !apiComponents ||
      !versionMaps ||
      apiComponents.length !== versionMaps.length
    ) {
      return;
    }
    (async () => {
      const _lessonComponents: LessonComponentBase[] = await Promise.all(
        apiComponents.map(async (component, index) => {
          //* apiComponents has an ordered list of components by position.
          const { position, required } = versionMaps[index];
          const { componentkey, published, parentkey } = component;
          const lessonComponent: LessonComponentBase = {
            componentkey,
            published,
            parentkey,
            ...component.assets,
            position,
            required
          };
          return lessonComponent;
        })
      );
      setLessonComponents(cloneDeep(_lessonComponents));
    })();
  }, [apiComponents, versionMaps]);

  function update() {
    updateComponents();
    updateVersionMaps();
  }

  return {
    loading: !lessonComponents,
    error: componentsLoadError || mapsLoadError,
    lessonComponents,
    update
  };
}
